import { render, staticRenderFns } from "./vAccRegistrar.vue?vue&type=template&id=9e81af8c&"
import script from "./vAccRegistrar.vue?vue&type=script&lang=js&"
export * from "./vAccRegistrar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports